import type { ClassToken, ItemQuality, Role } from "./types";

export const QUALITY_LABEL: Record<ItemQuality, string> = {
  poor: "Poor",
  common: "Common",
  uncommon: "Uncommon",
  rare: "Rare",
  epic: "Epic",
  legendary: "Legendary",
  artifact: "Artifact",
  heirloom: "Heirloom",
};

/** Tailwind text color class for an item quality. */
export function qualityTextClass(q: ItemQuality): string {
  return `text-quality-${q}`;
}

/** Tailwind text color class for a class token. */
export function classTextClass(c: ClassToken): string {
  return `text-class-${c}`;
}

/** Inline CSS color value for a class token (use in style={{ color: ... }}). */
export function classColorVar(c: ClassToken): string {
  return `var(--color-class-${c})`;
}

export const ROLE_LABEL: Record<Role, string> = {
  tank: "Tank",
  healer: "Healer",
  dps: "DPS",
};

export const ROLE_COLOR: Record<Role, string> = {
  tank: "text-info",
  healer: "text-success",
  dps: "text-danger",
};

/** Slot label for the addon's INVTYPE_ values. */
export const SLOT_LABEL: Record<string, string> = {
  INVTYPE_HEAD: "Head",
  INVTYPE_NECK: "Neck",
  INVTYPE_SHOULDER: "Shoulder",
  INVTYPE_CLOAK: "Back",
  INVTYPE_CHEST: "Chest",
  INVTYPE_WRIST: "Wrist",
  INVTYPE_HAND: "Hands",
  INVTYPE_WAIST: "Belt",
  INVTYPE_LEGS: "Legs",
  INVTYPE_FEET: "Feet",
  INVTYPE_FINGER: "Ring",
  INVTYPE_TRINKET: "Trinket",
  INVTYPE_WEAPON: "1H Weapon",
  INVTYPE_2HWEAPON: "2H Weapon",
  INVTYPE_WEAPONMAINHAND: "Main Hand",
  INVTYPE_WEAPONOFFHAND: "Off Hand",
  INVTYPE_HOLDABLE: "Off Hand",
  INVTYPE_SHIELD: "Shield",
  INVTYPE_RANGED: "Ranged",
};
